module.exports = __webpack_public_path__ + "media/images/profile-missing-cropped_large-0db4e7c37654e955fc5f16f8f21e3f03a93b2a255fb3cee04680cf305671df61.jpg";